import { FormControl, Validators } from '@angular/forms';

export class CustomValidators extends Validators {

	static validateCurrency(control: FormControl) {
		if (control.value && control.value.length > 0) {
			if (/^[0-9]+(\.[0-9]{1,2})?$/.test(control.value)) {
				return { invalid: true };
			}
		}

		return null;
	}
}


// WEBPACK FOOTER //
// ./src/app/validators/customValidators.ts